import React, { useEffect, useMemo, useRef, useState } from 'react';
import 'leaflet.fullscreen';
import { MapContainer, Polyline, } from 'react-leaflet';

import { useDetailsContext } from '../details';
import LeafletLayers from './leafletlayers';
import RouteMarker from './RouteMarker';
import { WaypointMarker } from './WaypointMarker';

import './map.css';

const Map = ({ activityId, timeFormatError, handleDeleteWaypoint, handleAddWaypoint }) => {
  const [state, dispatch] = useDetailsContext();
  const { route } = state.selectedRoute;

  const mapRef = useRef();
  const routeRef = useRef();
  const routeThickRef = useRef();

  const [routeCenter, setRouteCenter] = useState(null);

  // When route changes
  useMemo(() => {
    if (route) {
      if (routeRef.current) {
        // Move map to route bounds with padding to accomodate Elevation Map
        mapRef.current.fitBounds(routeRef.current.getBounds());
      }
      if (mapRef.current) mapRef.current.invalidateSize();
      const midPoint = Math.round(route.length / 2);
      setRouteCenter([route[midPoint].lat, route[midPoint].lon]);
    }

    // Remove current route from map when opening different route or unmounting
    return () => {
      if (mapRef) dispatch({ type: "SET_WAYPOINTS", payload: [] });
    };
  }, [route, dispatch]);

  
  // Change current map view according to the active wpt
  useEffect(() => {
    const wpt = state.activeWaypoint;
    if (wpt) {
      let currentZoom = wpt.type === 'table' ? 17 : mapRef.current.getZoom();
      mapRef.current.setView([wpt.lat, wpt.lon], currentZoom);
    }
  }, [state.activeWaypoint]);

  useEffect(() => {
    console.log("Update bounds");
    if (routeRef.current) mapRef.current.fitBounds(routeRef.current.getBounds());
  }, [state.selectedRoute]);

  return (
    <div id="map-canvas" className='leaflet-container'>
      <MapContainer ref={mapRef}
        center={routeCenter}
        zoom={12}
        scrollWheelZoom={window.innerWidth > 800 ? true : false}
        maxZoom={35}
        minZoom={6}
        boxZoom={true}
        paddingBottomRight={[0, 100]}
        fullscreenControl={true}
        fullscreenControlOptions={{position: 'topright'}}
      >
      {state.waypoints.map((wpt) =>
        <WaypointMarker key={`wpt${wpt.id}`}
            wpt={wpt}
            activityId={activityId}
            timeFormatError={timeFormatError}
            handleDeleteWaypoint={handleDeleteWaypoint}
            /> )}
        <RouteMarker route={route} 
          activityId={activityId}
          handleAddWaypoint={handleAddWaypoint}
          />
        <Polyline
          ref={routeThickRef}
          positions={state.selectedRoute ? [state.selectedRoute.route.map((e) => [e.lat, e.lon])] : [[0,0],[1,1]]}
          color="#fff"
          weight={9}
        />
        <Polyline
          ref={routeRef}
          positions={state.selectedRoute ? [state.selectedRoute.route.map((e) => [e.lat, e.lon])] : [[0,0],[1,1]]}
          color="#ff4500"
          weight={4}
          />
        <LeafletLayers />
      </MapContainer>
    </div>
  );
};

export default Map;